import React, { useEffect, useState } from "react";
import Select from "react-select";
import { showErrorToast } from "../Constant/Notification";
import InterestedTagService from "../Services/InterestedTagService";
import teamService from "../Services/TeamService";
import ReAssignLead from "../Services/ReAssignLead";
import { useNavigate } from "react-router-dom";
import Loader from "../Constant/Loader";

const FilterContainer = ({statusId}) => {
  const [interestedTags, setInterestedTags] = useState([]);
  const [interestedTagOption, setInterestedTagOption] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('')
  const [selectedUser, setSelectedUser] = useState('')
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false)
const [filteredCount, setFilteredcount] = useState('')
  const handleChange = (selectedOptions) => {
    setInterestedTags(selectedOptions);
  };

  const userData = JSON.parse(localStorage.getItem("userData"));
    // console.log(userData)
    const userRole = userData?.user?.role;
const navigate = useNavigate()
  const formatToDDMMYYYY = (date) => {
    const [yyyy, mm, dd] = date.split('-');
    return `${mm}-${dd}-${yyyy}`;
  };
  useEffect(() => {
    (async () => {
      try {
        const response = await InterestedTagService.fetchInterestedTag();
        const data = response.data;
        // setInterestedTags();
        let optionsArray = [];
        data.forEach((item) => {
          optionsArray.push({ value: item.id, label: item.name });
        });
        setInterestedTagOption(optionsArray);
      } catch (error) {
        showErrorToast(error.response.data);
      }

      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams;
        console.log(data)
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
        // Handle error if needed
      }



    })();
  }, []);

  useEffect(() => {
    const fetchUsersByTeam = async () => {
      if (selectedTeam) {
        console.log(selectedTeam)
        try {
          const response = await teamService.getTeamData(selectedTeam); // Pass selectedTeam
          const data = response.data;
          console.log(data)
          const combinedUsers = [
            ...data.BOD.map(bod => ({ name: bod.name, id: bod.id })),
            { name: data.MD.name, id: data.MD.id },
            ...data.members.map(member => ({ name: member.name, id: member.id }))
          ];

          setUsers(combinedUsers);
        console.log(users)

        } catch (error) {
          console.error("Error fetching users by team:", error);
          showErrorToast("Error fetching users");
        }
      }
    };

    fetchUsersByTeam();
  }, [selectedTeam]);

  const handleSubmit =async () => {
    console.log("handleSubmit called");
    // Check if startDate, endDate, and selectedTeam are provided
    if (!startDate) {
      showErrorToast("Please select a start date.");
      return;
    }

    if (!endDate) {
      showErrorToast("Please select an end date.");
      return;
    }
    const formattedStartDate = formatToDDMMYYYY(startDate);
      const formattedEndDate = formatToDDMMYYYY(endDate);

    if (!selectedTeam) {
      showErrorToast("Please select a team.");
      return;
    }

    const interestedTagIds = interestedTags.map(tag => tag.value);

    const filterData = {
      status: statusId,
      teamId: selectedTeam,
      membersId: selectedUser || null,
      startDate:formattedStartDate,
      endDate:formattedEndDate,
      interestedTagId:interestedTagIds,
    };
    setLoading(true)
  try{
    const response = await ReAssignLead.getReAssignCount(filterData)
    const data = response.data
    const reAssignLeadsId = data.reAssignLeads;
    console.log(reAssignLeadsId)
    // setFilteredcount(data.retrySuitableLeadCount)
    if(userRole === "Admin"){
      navigate("/admin/reassign-lead", {state: {leadIds:reAssignLeadsId, filteredLeadCount: data.count}})
    }else if(userRole === "CMO"){

      navigate("/cmo/reassign-lead", {state: {leadIds:reAssignLeadsId, filteredLeadCount: data.count}})

    }

  }catch(error){
    showErrorToast(error.response);

  }finally{
    setLoading(false)
  }
    // console.log("Filter data to be submitted:", filterData);
  }

  return (
    <>
    {loading && <Loader/>}
      <div className="w-full p-10 shadow-md rounded-md flex flex-col bg-white">
        <h1 className="text-2xl font-semibold">Filters</h1>

        <div className="flex mt-5">
          <div className="flex gap-14">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-lg 3xl:text-[30px] 3xl:mb-11 font-semibold mb-2 whitespace-nowrap"
                htmlFor="start-date"
              >
                Start Date
              </label>
              <input
                type="date"
                id="start-date"
                className="w-full px-3 py-2 border rounded-lg 3xl:text-[25px]  focus:outline-none focus:ring-2 focus:ring-green-600"
                value={startDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label
                className="block text-gray-700 text-lg 3xl:text-[30px] 3xl:mb-11 font-semibold mb-2 whitespace-nowrap"
                htmlFor="end-date"
              >
                End Date
              </label>
              <input
                type="date"
                id="end-date"
                className="w-full px-3 py-2 border rounded-lg  3xl:text-[25px] focus:outline-none focus:ring-2 focus:ring-green-600"
                value={endDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="">
<h1 className="w-full mt-4 text-gray-700 text-lg font-medium">Select Team:</h1>
        <select
          name=""
          className="  rounded-md w-full shadow border  h-10 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id=""
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}

        >
          <option value="">Select Team</option>

          {teams.map((item, index) => {
            return (
              <option key={index} value={item.teamId}>
                {item.name}
              </option>
            );
          })}
        </select>
        </div>



        <div className="">
<h1 className="w-full mt-4 text-gray-700 text-lg font-medium">Select User:</h1>
        <select
          name=""
          className="  rounded-md w-full shadow border  h-10 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id=""
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}

        >
          <option value="">All Users</option>

          {users.map((user, index) => (
              <option key={index} value={user.id}>
                {user.name}
              </option>
            ))}
        </select>
        </div>
        <label
          className="w-full mt-4 text-gray-700 text-lg font-medium"
          htmlFor="interest-tag"
        >
          Add a Interest Tag
        </label>

        <Select
          className="w-full py-2  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={interestedTags}
          onChange={handleChange}
          options={interestedTagOption}
          isMulti
            menuPlacement="top"
          onMenuOpen={() => setMenuOpen(true)}
          onMenuClose={() => setMenuOpen(false)}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: "100px",
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: "#339E79", // Change background color of the chip
              borderRadius: "4px",
              padding: "2px 4px",
              color: "white", // Change text color of the chip
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              color: "white", // Change text color of the label inside the chip
            }),
          }}
          placeholder="Select Interested Tags of leads :"
        />

        <div className="flex items-center justify-center mt-3">
          <button
            className="bg-customGreen text-white w-auto rounded-md text-lg font-normal px-3"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default FilterContainer;
